import React from "react";
import Attachments from "../BasicInfo/Attachments";
import PropTypes from "prop-types";

const FramingAttachments = ({ attachments, onAttachmentsUpdated }) => (
  <Attachments
    attachments={attachments}
    type={"framing"}
    onAttachmentsUpdated={onAttachmentsUpdated}
  />
);

FramingAttachments.propTypes = {
  attachments: PropTypes.array,
  onAttachmentsUpdated: PropTypes.func,
};

export default FramingAttachments;
